'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ModalDialog;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ModalDialog(props) {
  var visible = props.visible ? 'visible' : '';
  function cancel(e) {
    e.stopPropagation();
  }
  return _react2.default.createElement(
    'div',
    { className: 'modal ' + visible, onClick: props.onClose },
    _react2.default.createElement(
      'div',
      { className: 'inner', onClick: cancel },
      props.children,
      _react2.default.createElement(
        'div',
        { className: 'close', onClick: props.onClose },
        'x'
      )
    )
  );
}


//////////////////
// WEBPACK FOOTER
// ./client/components/ModalDialog.jsx
// module id = 63
// module chunks = 0